<template>
  <div class="sendInvitation">
    <div v-if="sourceIsH5" class="navBar-wrap">
      <NavBar :narBarTitle="$t('发送邀约链接')" />
    </div>
    <div class="content" ref="imageDom" v-if="!ifDisabled">
      <div class="logo-box"><img :src="logo" alt="" ref="logo" /></div>
      <div class="content-companyName">{{ user.companyName }}</div>
      <img src="@/assets/images/sendInvitationLine.png" alt="" class="sendInvitationLine" />
      <div class="content-text">{{ $t('邀您来访') }}</div>
      <div class="content-tips">{{ $t('微信扫码二维码填写预约来访信息') }}</div>
      <vue-qr :text="invitaUrl" :size="142" :margin="3" ref="qrCode" class="code"></vue-qr>
      <img src="@/assets/images/sendInvitationOR.svg" alt="" class="sendInvitationOR" />
      <div class="button-link" @click="doShowToast">
        <img src="@/assets/images/sendInvitationLink.svg" alt="" class="sendInvitationLink" />{{ $t('复制邀约链接') }}
      </div>
      <div class="content-tips">
        {{ $t('或者复制邀约链接填写预约来访信息') }}
      </div>
    </div>
    <div v-else class="content">
      <img src="@/assets/images/sendInvitationLine.png" alt="" class="sendInvitationLine" />
    </div>
    <div class="button" @click="toInvite">{{ $t('新建邀约') }}</div>
    <van-dialog v-model="showToast" confirmButtonColor="#3972FF" @confirm="IsDoOk()" class="outsiderStyle"
      :confirmButtonText="$t('取消')">
      <template #title>
        <div class="outsider-info">
          <div class="outsider-title">{{ $t('复制邀约链接') }}</div>
          <div class="outsider-tip">{{ $t('（访客收到链接后自行补充访客个人信息）') }}</div>
          <div class="linkTitle">{{ $t('接待人信息') }}</div>
          <div class="linkText" v-if="user.companyId != 303">{{ intervieweeName }}</div>
          <div class="linkText">{{ address }}</div>
          <div class="linkTitle">{{ $t('接待方式') }}</div>
          <div class="linkText" style="margin-bottom: 20px;">{{ $t(registerMode) }}</div>
          <div class="button-link-zh" @click="setCopyUrl('zh-CN')">
            <img src="@/assets/images/sendInvitationLink.svg" alt="" class="sendInvitationLink" />{{ $t('复制中文链接') }}
          </div>
          <div class="button-link-en" @click="setCopyUrl('en-US')">
            <img src="@/assets/images/sendInvitationLinkEN.svg" alt="" class="sendInvitationLink" />{{ $t('复制英文链接') }}
          </div>
        </div>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import NavBar from '@/components/newNavBar'
import dayjs from 'dayjs'
import vueQr from 'vue-qr'
import Vue from 'vue'
import { Button, Toast, Dialog } from 'vant'
import { getCompanyInfo } from '@/services/api'
import html2canvas from 'html2canvas'
import { shareWX } from '@/utils/weixinSDK.js'
import { shareDD } from '@/utils/getDingCode.js'

Vue.use(Button)
Vue.use(Toast)
Vue.use(Dialog)

export default {
  name: 'SendInvitation',
  components: {
    NavBar,
    vueQr,
  },
  data() {
    return {
      user: {},
      invitaUrl: null,
      logo: null,
      shareImg: null,
      showShare: false,
      ifWX: false,
      sourceIsH5: true,
      ifDisabled: false,
      showToast: false,
      companyCode: null,
      intervieweeId: null,
      address: null,
      registerMode: null,
      intervieweeName: null,
      spaceName: null,
      robotLocation: null,
    }
  },
  methods: {
    toInvite() {
      this.$router.push('/newInvitation')
    },
    doShowToast() {
      this.showToast = true
    },
    IsDoOk() {
      this.showToast = false
    },
    setCopyUrl(language) {
      let shareUrl = `${window.location.origin
        }/newwork-h5-iframe/visitorInvitation/?id=${this.user.id
        }&name=${encodeURIComponent(
          this.user.name
        )}&shareId=${dayjs().valueOf()}&companyId=${this.user.companyId
        }&companyCode=${this.companyCode}&shareDate=${dayjs().format('YYYY-MM-DD')}&localLanguage=${language}&intervieweeId=${this.intervieweeId}&address=${encodeURIComponent(this.address)}&registerMode=${this.registerMode}&intervieweeName=${encodeURIComponent(this.intervieweeName)}&spaceName=${encodeURIComponent(this.spaceName)}&robotLocation=${encodeURIComponent(this.robotLocation)}`
      this.invitaUrl = shareUrl
      this.showToast = false
      this.copyUrl()
    },
    copyUrl() {
      // 1、创建DOM textarea框
      const textarea = document.createElement("textarea");
      // 2、隐藏textarea
      textarea.style = { opacity: 0, height: 0, lineHeight: 0, fontSize: 0 }
      // 3、将指定文本赋值给textarea
      textarea.value = this.invitaUrl
      // 4、将textarea插入文档
      document.body.appendChild(textarea)
      // 5、选中文本
      textarea.select()
      // 6、复制到剪切板
      document.execCommand('copy')
      // 7、复制成功后提示
      Toast(this.$t('邀约链接已复制，快去粘贴吧'))
      // 8、 销魂DOM
      document.body.removeChild(textarea)
    },
    async getLogo(companyCode) {
      const res = await getCompanyInfo(companyCode)
      this.logo = res.logo + '?' + new Date().valueOf()
      if (
        window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        'micromessenger'
      ) {
        let url = `${window.location.origin}/newwork-h5-iframe${this.$route.path}`
        let option = {
          shareTitle: this.$t('您有一个来访信息登记邀请！'),
          shareDesc: this.$t('请及时填写哦~'),
          shareUrl: this.invitaUrl,
          shareImg: this.logo,
        }
        shareWX(this.user.companyId, url, option)
        this.ifWX = true
      }
      this.$refs.imageBox.onload = () => {
        this.toImage()
      }
    },
    toImage() {
      html2canvas(this.$refs.imageDom, { useCORS: true }).then((canvas) => {
        this.shareImg = canvas.toDataURL('image/jpeg')
        // this.showShare = true
      })
    },
    share() {
      let option = {
        shareTitle: this.$t('您有一个来访信息登记邀请！'),
        shareDesc: this.$t('请及时填写哦~'),
        shareUrl: this.invitaUrl,
        shareImg: this.logo,
      }
      shareDD(option)
    },
  },
  created() {
    if (this.$route.query.ifDisabled) {
      this.ifDisabled = true
    } else {
      this.ifDisabled = false
      let companyCode = JSON.parse(localStorage.getItem('cCode')).code
      this.user = JSON.parse(localStorage.getItem('user'))
      this.companyCode = companyCode
      this.intervieweeId = this.$route.query.intervieweeId
      this.address = this.$route.query.address
      this.registerMode = this.$route.query.registerMode
      this.intervieweeName = this.$route.query.intervieweeName
      this.spaceName = this.$route.query.spaceName
      this.robotLocation = this.$route.query.robotLocation
      let shareUrl = `${window.location.origin
        }/newwork-h5-iframe/visitorInvitation/?id=${this.user.id
        }&name=${encodeURIComponent(
          this.user.name
        )}&shareId=${dayjs().valueOf()}&companyId=${this.user.companyId
        }&companyCode=${companyCode}&shareDate=${dayjs().format('YYYY-MM-DD')}&intervieweeId=${this.$route.query.intervieweeId}&address=${encodeURIComponent(this.$route.query.address)}&registerMode=${this.$route.query.registerMode}&intervieweeName=${encodeURIComponent(this.$route.query.intervieweeName)}&spaceName=${encodeURIComponent(this.$route.query.spaceName)}&robotLocation=${encodeURIComponent(this.$route.query.robotLocation)}`
      this.invitaUrl = shareUrl
      this.getLogo(companyCode)
    }
  },
  mounted() {
    this.$refs.logo.onload = () => {
      let height = this.$refs.logo.height
      let width = this.$refs.logo.width
      if (height >= width && height >= 80) this.$refs.logo.height = 80
      if (width > height && width >= 94) this.$refs.logo.width = 94
    }
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
    // if (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
    //   let url = `${window.location.origin}/newwork-h5${this.$route.path}`
    //   let option = {
    //     shareTitle: '您有一个来访信息登记邀请！',
    //     shareDesc: '请及时填写哦~',
    //     shareUrl: this.invitaUrl,
    //     shareImg: this.logo,
    //   }
    //   shareWX(this.user.companyId, url, option)
    //   this.ifWX = true
    // }
  },
}
</script>
<style lang="less" scoped>
.sendInvitation {
  width: 100%;
  min-height: 100vh;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('../../../assets/images/sendInvitationBG.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 68px;
  padding-bottom: 20px;

  .navBar-wrap {
    height: 44px;
    width: 100%;
    background-color: #ffffff;
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
  }

  .content {
    width: 343px;
    height: 530px;
    box-sizing: border-box;
    border-radius: 16px;
    background-image: url('../../../assets/images/sendInvitationContentBG.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    .logo-box {
      width: 127px;
      height: 112px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 94px;
        max-height: 80px;
      }
    }

    .content-companyName {
      width: 300px;
      height: 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #1e2329;
      line-height: 22px;
      text-align: center;
      font-style: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .code {
      width: 142px;
      height: 141px;
      margin-top: 13px;
    }

    .sendInvitationLine {
      margin-top: 16px;
      margin-bottom: 12px;
      width: 288px;
      height: 6px;
    }

    .sendInvitationOR {
      margin-top: 16px;
      margin-bottom: 16px;
      width: 203px;
      height: 17px;
    }

    .sendInvitationLink {
      width: 24px;
      height: 24px;
    }

    .content-text {
      height: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #1e2329;
      line-height: 32px;
      text-align: center;
      font-style: normal;
      margin-bottom: 10px;
    }

    .content-tips {
      height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #707a8a;
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }

    .button-link {
      height: 40px;
      background: #ffffff;
      border-radius: 20px;
      border: 1px solid #3972ff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #3972ff;
      line-height: 40px;
      text-align: left;
      font-style: normal;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 4px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  .button {
    width: 335px;
    height: 48px;
    background: #167aff;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
    font-style: normal;
    margin-top: 30px;
  }
}

.outsider-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.outsider-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #1E2329;
  margin-bottom: 5px;
}

.outsider-tip {
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
}

.linkTitle {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
  margin-top: 10px;
}

.linkText {
  font-size: 14px;
  color: #000;
  margin-bottom: 5px;
}

.button-link-zh {
  height: 56px;
  width: 240px;
  background: #3972FF;
  border-radius: 32px;
  border: 1px solid #3972FF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.button-link-en {
  height: 56px;
  width: 240px;
  background: #ffffff;
  border-radius: 32px;
  border: 1px solid #3972ff;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #3972ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
